/* src/app/system-utils/print-screen-alert/print-screen-alert.component.scss */
.fullscreen-alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--tem-ink);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.alert-content {
  background-color: var(--tem-border);
  padding: 20px;
  border-radius: 10px;
}
/*# sourceMappingURL=print-screen-alert.component.css.map */
